import {RequestFactory} from "@/requests/RequestFactory";
const lancamentoRequest = RequestFactory.get("lancamento");
const storageRequest = RequestFactory.get("storage");

export default {
  namespaced: true,

  state: {
    isFetching: false,
    items: {},
  },

  mutations:{
    deleteArquivo (state, {itemId, indexArquivo}) {
      state.items[itemId].arquivos.splice(indexArquivo, 1)
    },
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    }    
  },
  
  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchLancamentos({commit}, indicadorId) {
      const resource = 'lancamento'
      return lancamentoRequest.findByIndicadorId(indicadorId).then(response => {
        response.data.forEach(item => commit('setItem', {item, resource}, {root: true}))
      });
    },

    deletarLancamento ({commit}, payload) {
      return lancamentoRequest.delete(payload).then(response => {
        let payloadDelete = {resource: 'lancamento', itemId: payload.lancamentoId}
        commit('deleteItem', payloadDelete, {root: true})

        return response.data
      })
    },

    criarLancamento({commit, dispatch}, payload) {
      dispatch('requestOn');
      return lancamentoRequest.post(payload.indicadorId, payload.lancamento).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'lancamento', item: response.data}
        const payloadIndicador = {resource: 'indicador', item: response.data.indicador}
        commit('setItem', payload, {root: true})
        commit('setItem', payloadIndicador, {root: true})        

        const notification = {
          type: 'success',
          message: 'Lançamento criado com sucesso'
        }        
        dispatch('notification/add', notification, {root: true})
        return response.data
      }).catch(error => {
        dispatch('requestOff');
        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }
        
        dispatch('notification/add', notification, {root: true})

        return error

      });
    },

    editarLancamento({commit, dispatch}, payload) {
      dispatch('requestOn');
      return lancamentoRequest.put(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'lancamento', item: response.data}
        const payloadIndicador = {resource: 'indicador', item: response.data.indicador}
        commit('setItem', payload, {root: true})
        commit('setItem', payloadIndicador, {root: true})        

        const notification = {
          type: 'success',
          message: 'Lançamento editado com sucesso'
        }        
        dispatch('notification/add', notification, {root: true})
        return response.data
      }).catch(error => {
        dispatch('requestOff');
        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }
        
        dispatch('notification/add', notification, {root: true})

        return error

      });
    },
    
    realizarMonitoramento({commit, dispatch}, payload) {
      dispatch('requestOn');
      lancamentoRequest.putMonitoramento2(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'lancamento', item: response.data}
        const payloadIndicador = {resource: 'indicador', item: response.data.indicador}
        commit('setItem', payload, {root: true})
        commit('setItem', payloadIndicador, {root: true})

        const notification = {
          type: 'success',
          message: 'Monitoramento realizado com sucesso'
        }
        return dispatch('notification/add', notification, {root: true})         
      }).catch(error => {
        dispatch('requestOff');
        console.log('error: ', error)
        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }
        
        dispatch('notification/add', notification, {root: true})

        return error
      });
    },
    
    adicionarLancamento({commit, dispatch}, lancamento) {
      dispatch('requestOn');
      const payload = {resource: 'lancamento', item: lancamento}
      const payloadIndicador = {resource: 'indicador', item: lancamento.indicador}
      commit('setItem', payload, {root: true})
      commit('setItem', payloadIndicador, {root: true})
      const notification = {
        type: 'success',
        message: 'Lançamento salvo com sucesso'
      }
      dispatch('requestOff');
      return dispatch('notification/add', notification, {root: true})
    },
    
    editarMonitoramento({commit, dispatch}, payload) {
      dispatch('requestOn');
      lancamentoRequest.putMonitoramento(payload).then(response => {
        dispatch('requestOff');
        const resource = 'lancamento'
        const resourceIndicador = 'indicador'
        const item = response.data
        const indicador = response.data.indicador
        console.log(indicador)
        commit('setItem', {item, resource}, {root: true})
        commit('setItem', {indicador, resourceIndicador}, {root: true})
        
        const notification = {
          type: 'success',
          message: 'Monitoramento atualizado com sucesso'
        }
        return dispatch('notification/add', notification, {root: true})

      }).catch(error => {
        dispatch('requestOff');
        return error;
      });


    },
    
    enviarParaMonitoramento({commit, dispatch}, payload) {
      dispatch('requestOn');
      lancamentoRequest.putEnviaMonitoramento(payload).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'lancamento', item: response.data}
        const payloadIndicador = {resource: 'indicador', item: response.data.indicador}
        commit('setItem', payload, {root: true})
        commit('setItem', payloadIndicador, {root: true})

        const notification = {
          type: 'success',
          message: 'Lançamento enviado com sucesso para monitoramento'
        }
        return dispatch('notification/add', notification, {root: true})
      }).catch(error => {
        dispatch('requestOff');
        return error;
      });
    },

    deleteArquivo({commit, dispatch}, payload) {
      dispatch('requestOn');
      return storageRequest.delete(payload).then(response => {
        dispatch('requestOff');
        const commitPayload = {
          'itemId': payload.lancamentoId,
          'indexArquivo': payload.indexArquivo
        };
        commit('deleteArquivo', commitPayload)        

        const notification = {
          type: 'success',
          message: 'Arquivo removido com sucesso'
        }
        dispatch('notification/add', notification, { root: true })        

        return response.data
      }).catch(error => {
        dispatch('requestOff');
        return error;
      });

    },    
  },

  getters: {
    byIndicadorId: (state) => indicadorId => {
      if(state.items){
        return Object.values(state.items)
        .filter(lancamento => lancamento.indicador.id === indicadorId)
      }
      return {}
    },
    byLancamentoPaiId: (state) => lancamentoPaiId => {
      if (state.items) {
        return (Object.values(state.items).filter(item => item.lancamentoFontePaiId === lancamentoPaiId));
      }
      return []
    },

  },
}
